﻿import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";
import {Core} from "./Core";

export class BoostersManager extends MonoBehaviour {

    Awake() {
        super.Awake();
        this.onPlayerChanged = this.onPlayerChanged.bind(this);

        this.IsBubbleActive = false;
        this.IsCreaturesDiscountActive = false;
        this.IsIncomeActive = false;
        this.IsIncome2Active = false;
        this.bubbleTimer = null; // PlayerTimer
        this.incomeTimer = null; // PlayerTimer
        this.creatureDiscountTimer = null; // PlayerTimer
        this.income2Timer = null; // PlayerTimer
    }

    Init() {
        Core.Player.on("Changed", this.onPlayerChanged);
    }

    onPlayerChanged() {
        if (!Core.Player.Initialized) return;

        this.bubbleTimer = Core.Player.Timers.GetTimerById(
            Core.Player.Timers.bubbleBoosterTimerId
        );
        this.incomeTimer = Core.Player.Timers.GetTimerById(
            Core.Player.Timers.incomeBoosterTimerId
        );
        this.creatureDiscountTimer = Core.Player.Timers.GetTimerById(
            Core.Player.Timers.discountBoosterTimerId
        );
        this.income2Timer = Core.Player.Timers.GetTimerById(
            Core.Player.Timers.incomeX4BoosterTimerId
        );

        this.IsBubbleActive = this.bubbleTimer && !this.bubbleTimer.IsFinished;
        this.IsCreaturesDiscountActive = this.creatureDiscountTimer && !this.creatureDiscountTimer.IsFinished;
        this.IsIncomeActive = this.incomeTimer && !this.incomeTimer.IsFinished;
        this.IsIncome2Active = this.income2Timer && !this.income2Timer.IsFinished;
    }

    AddBoosterTime(boosterType, seconds) {
        let timer = Core.Player.Timers.GetBoosterTimer(boosterType);
        if (timer && timer.IsFinished) {
            Core.Player.Timers.RemoveTimer(timer.tId);
            timer = null;
        }
        timer = timer || Core.Player.Timers.AddBoosterTimer(0, boosterType);
        timer.AddSeconds(seconds);
    }
}
